import { images } from "@/config/content";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { CallButton, WhatsAppButton, LocationButton } from "@/components/ActionButtons";

export function FinalCTA() {
  const { t } = useLang();
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-carbon py-24 md:py-32">
      <div className="absolute inset-0 z-0">
        <img src={images.cta} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/85 to-carbon/70" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center lg:px-8">
        <Reveal>
          <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ice sm:text-5xl lg:text-6xl">
            {t.finalCta.titleL1}
            <span className="mt-1 block text-amber">{t.finalCta.titleL2}</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-steel md:text-lg">{t.finalCta.text}</p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <CallButton size="lg" testId="final-call-btn" label={t.common.callEmme} />
            <LocationButton size="lg" testId="final-location-btn" />
            <WhatsAppButton size="lg" testId="final-whatsapp-btn" />
          </div>
          <p className="mt-6 text-sm text-steel">{t.finalCta.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
